import * as yup from 'yup';

export default yup.object().shape({
  email: yup
    .string()
    .trim()
    .email('Email Address is not valid')
    .required('Email Address is required'),
});
